<template>
  <div class="pop-record" v-show="isPop">
    <h2>大额充值退款/支付记录</h2>
    <ul>
      <li>
        <span>订单编号</span>
        <span>订单时间</span>
        <span>用途</span>
        <span>金额</span>
        <span>产品及数量</span>
        <span>余额</span>
      </li>
    </ul>
    <ul class="con" v-if="recordList.length > 0">
      <li v-for="item in recordList" :key="item.serialId">
        <span>{{(item.status == 3|item.status == 4) ? '-- ' : item.paymentId}}</span>
        <span>{{(item.status == 3 ? item.refundDt  : item.payDt) | dateFormat("yyyy-MM-dd")}}</span>
        <span>{{item.status | statusUse}}</span>
        <span>{{item.status != 1 ? '- ' : '+' }} ¥ {{item.amount}}</span>
        <span>{{(item.status == 3 | item.status == 4)? '-- ' : item.productName + '/' + item.month + '月'}}</span>
        <span>¥ {{item.surplusAmount}}</span>
      </li>
    </ul>
    <div class="empty" v-else>
      <img src="../../assets/images/pay/empty.png" alt="">
      <p>暂无记录</p>
    </div>
    <span class="close" @click="close">x</span>
  </div>
</template>

<script>
export default {
  props: ['isPop', 'recordList'],
  methods: {
    close () {
      this.$emit('close', false)
    }
  },
  filters: {
    statusUse (val) {
      if (val == 1) {
        return '充值'
      } else if (val == 2) {
        return '消费'
      } else if (val == 3) {
        return '退款'
      } else {
        return '退款中'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-record{
  background: #FFFFFF;
  border: 2px solid #166EFF;
  box-shadow: 0 6px 12px 0 rgba(188,188,188,0.65);
  width: 820px;
  position: fixed;
  left: 50%;
  margin-left: -410px;
  top: 20%;
  z-index: 9;
  h2{
    background: #F7F9FD;
    line-height: 50px;
    font-size: 25px;
    color: #166EFF;
    padding-left: 20px;
  }
  ul{
    li{
      line-height: 50px;
      font-size: 16px;
      border-bottom: 1px solid #E3E3E3;
      height: 50px;
      &:nth-child(1) {
        color: #666666;
      }
      >span{
        float: left;
        text-align: center;
        box-sizing: border-box;
        &:nth-child(1) {
          width: 100px;
        }
        &:nth-child(2) {
          width: 140px;
        }
        &:nth-child(3) {
          width: 90px;
        }
        &:nth-child(4) {
          width: 120px;
          text-align: right;
        }
        &:nth-child(5) {
          width: 230px;
        }
        &:nth-child(6) {
          width: 120px;
          text-align: right;
          padding-right: 20px;
        }
      }
    }
    &.con{
      color: #222222;
      max-height: 420px;
      overflow-x: hidden;
      overflow-y: auto;
      li{
        &:nth-child(1) {
          color: #222222;
        }
      }
    }
  }
  .empty{
    text-align: center;
    height: 300px;
    font-size: 18px;
    color: #999999;
    img{
      display: block;
      margin: 60px auto 20px;
    }
  }
  .close{
    display: block;
    position: absolute;
    top: 5px;
    right: 5px;
    background: #EF3939;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 26px;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/order/PopRecord.vue